// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

export function formDataToJson(form: FormData): string;
export function formDataToJson(form: FormData, stringify: true): string;
export function formDataToJson(form: FormData, stringify: false): object;
export function formDataToJson(form: FormData, stringify: boolean = true): string | object {
    const object = {};
    form.forEach((value, key) => {
        // Reflect.has in favor of: object.hasOwnProperty(key)
        if (!Reflect.has(object, key)) {
            object[key] = value;
            return;
        }
        if (!Array.isArray(object[key])) {
            object[key] = [object[key]];
        }
        object[key].push(value);
    });
    return stringify ? JSON.stringify(object) : object;
}

// Converts a file uploaded using a standard input element into a base64 string
export function inputFileToBase64(file: any): Promise<any> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            // From stack overflow answer on, https://stackoverflow.com/questions/36280818/how-to-convert-file-to-base64-in-javascript
            // This removes the metadata at the beginning of the file and ensures the paddding is done correctly
            let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
            if (encoded.length % 4 > 0) {
                encoded += '='.repeat(4 - (encoded.length % 4));
            }
            resolve(encoded);
        };
        reader.onerror = (error) => reject(error);
    });
}
